// src/components/ServersParser/ServersParserKpiStats.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ServersParserKpiStats = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section className="sp-global-stats-section">
      <div className="sp-section-mono-title">
        <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" fill="none" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <path d="M3 9h18M9 21V9" />
        </svg>
        <span>{isEn ? 'Monitoring Metrics' : 'Показатели мониторингов'}</span>
      </div>

      <div className="sp-stats-quad-grid">
        {/* 1. Спарсено серверов */}
        <div className="sp-stat-hero-card">
          <svg className="sp-stat-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="12" r="10" />
            <path d="m4.93 4.93 4.24 4.24" />
            <circle cx="12" cy="12" r="4" />
          </svg>
          <div className="sp-stat-hero-card-inner">
            <div className="sp-stat-big-number">142,850</div>
            <div>
              <div className="sp-stat-label-title">
                {isEn ? 'Parsed Servers' : 'Спарсено серверов'}
              </div>
              <div className="sp-stat-sub-desc">
                {isEn ? 'Database of popular monitorings' : 'База данных популярных мониторингов'}
              </div>
            </div>
          </div>
        </div>

        {/* 2. Мониторингов */}
        <div className="sp-stat-hero-card">
          <svg className="sp-stat-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="12" r="10" />
            <line x1="2" x2="22" y1="12" y2="12" />
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
          </svg>
          <div className="sp-stat-hero-card-inner">
            <div className="sp-stat-big-number">18</div>
            <div>
              <div className="sp-stat-label-title">
                {isEn ? 'Monitorings' : 'Мониторингов'}
              </div>
              <div className="sp-stat-sub-desc">
                {isEn ? 'TopCraft, McMonitoring, HotMC etc.' : 'TopCraft, McMonitoring, HotMC и др.'}
              </div>
            </div>
          </div>
        </div>

        {/* 3. С уязвимостями */}
        <div className="sp-stat-hero-card">
          <svg className="sp-stat-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          <div className="sp-stat-hero-card-inner">
            <div className="sp-stat-big-number">12,430</div>
            <div>
              <div className="sp-stat-label-title">
                {isEn ? 'With Vulnerabilities' : 'С уязвимостями'}
              </div>
              <div className="sp-stat-sub-desc">
                {isEn ? 'Identified basic and critical flaws' : 'Выявлены базовые и критические бреши'}
              </div>
            </div>
          </div>
        </div>

        {/* 4. Суммарный онлайн */}
        <div className="sp-stat-hero-card">
          <svg className="sp-stat-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="8" r="5" />
            <path d="M20 21a8 8 0 1 0-16 0" />
          </svg>
          <div className="sp-stat-hero-card-inner">
            <div className="sp-stat-big-number">480K+</div>
            <div>
              <div className="sp-stat-label-title">
                {isEn ? 'Total Online' : 'Онлайн суммарно'}
              </div>
              <div className="sp-stat-sub-desc">
                {isEn ? 'Players on discovered servers' : 'Игроков на найденных серверах'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServersParserKpiStats;
